import React from "react";
import { useLazyBestSellingProducts } from "../../../../scans/hooks";
import { Card, ModernCardHeader } from "../../../../../components/cards";
import { EmptyList, Loading } from "../../../../../components";
import { BestSellingProductsTable } from "../../../components/best-products-table";
import { useDebounce } from "../../../../../hooks/useDebounce";

interface IBestSellingProducts {
  siteId: number;
  start?: string;
  end?: string;
  groupBy?: string;
}

export const BestSellingProducts: React.FC<IBestSellingProducts> = ({
  siteId,
  start,
  end,
  groupBy = "day",
}) => {
  const [search, { data, loading, error, fetchMore }] =
    useLazyBestSellingProducts();
  const [orderBy, setOrderBy] = React.useState("ca");
  const limit = 25;

  const [displayedSearch, setSearch] = React.useState("");
  const debouncedLimit = useDebounce(limit, 500);

  console.log({ error, data });

  React.useEffect(() => {
    search({
      variables: {
        siteId,
        where: {
          start,
          end,
        },
        groupBy,
        limit,
        offset: 0,
        orderBy,
      },
      fetchPolicy: "network-only",
    });
  }, []);

  React.useEffect(() => {
    search({
      variables: {
        siteId,
        where: {
          start,
          end,
        },
        groupBy,
        limit,
        offset: 0,
        orderBy,
      },
      fetchPolicy: "network-only",
    });
  }, [start, end, groupBy, orderBy, debouncedLimit]);

  return (
    <div className="w-full">
      <Card padding="md" className="mb-3 shadow-sm">
        <ModernCardHeader title="Les Meilleures Ventes" />

        <div className="flex gap-3 mt-3 mb-3">
          <div className="w-1/3">
            <label className="label">Trier par</label>
            <select
              className="input w-full"
              value={orderBy}
              onChange={(e) => setOrderBy(e.target.value)}
            >
              <option value="ca">Chiffre d'affaire</option>
              <option value="week">Nb Ventes</option>
            </select>
          </div>
        </div>

        {loading ? <Loading /> : null}
        {data?.bestSellingSiteProducts?.results?.length === 0 ? (
          <div className="mt-2">
            <EmptyList text="Aucune donnée disponible" />
          </div>
        ) : null}
        {(data?.bestSellingSiteProducts?.results?.length ?? 0) > 0 ? (
          <BestSellingProductsTable
            data={data?.bestSellingSiteProducts?.results?.map((r) => ({
              productImgUrl: r.productImgUrl,
              product: {
                id: r.productId,
                name: r.productName,
              },
              productQuantity: r.productQuantity ?? 0,
              price: r.price,
              salesSum: r.salesSum ?? 0,
              ca: r.ca,
            }))}
          />
        ) : null}

        {data?.bestSellingSiteProducts?.hasMore ? (
          <div className="w-full flex justify-center items-center">
            <button
              className="cursor-pointer inline-flex items-center justify-center px-4 py-2 text-sm text-white bg-primary-600 hover:bg-primary-700 rounded-md transition-colors mt-3"
              onClick={() =>
                fetchMore({
                  variables: {
                    siteId,
                    where: {
                      start,
                      end,
                    },
                    groupBy,
                    limit,
                    offset: data?.bestSellingSiteProducts?.results?.length,
                    orderBy,
                  },
                })
              }
            >
              Charger Plus
            </button>
          </div>
        ) : null}
      </Card>
    </div>
  );
};
